import InputAddressBS from './InputLocationsBS.jsx';

export default InputAddressBS;